import React, {useContext} from "react";
import Headroom from "react-headroom";
import "./Header.scss";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import StyleContext from "../../contexts/StyleContext";
import LanguageContext from "../../contexts/LanguageContext";
import {
  greeting,
  workExperiences,
  skillsSection,
  openSource,
  bigProjects
} from "../../portfolio";

function Header() {
  const {isDark} = useContext(StyleContext);
  const {isEnglish, toggleLanguage} = useContext(LanguageContext);
  const viewExperience = workExperiences.display;
  const viewOpenSource = openSource.display;
  const viewSkills = skillsSection.display;
  const viewProjects = bigProjects.display;
  
  return (
    <Headroom>
      <header className={isDark ? "dark-menu header" : "header"}>
        <a href="/" className="logo">
          <span className="logo-name">{greeting.username}</span>
        </a>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label
          className="menu-icon"
          htmlFor="menu-btn"
          style={{color: "white"}}
        >
          <span className={isDark ? "navicon navicon-dark" : "navicon"}></span>
        </label>
        <ul className={isDark ? "dark-menu menu" : "menu"}>
          {viewSkills && (
            <li>
              <a href="#skills">Skills</a>
            </li>
          )}
          {viewProjects && (
            <li>
              <a href="#projects">{isEnglish ? "Projects" : "Projetos"}</a>
            </li>
          )}
          {viewExperience && (
            <li>
              <a href="#experience">{isEnglish ? "Experience" : "Experiência"}</a>
            </li>
          )}
          {viewOpenSource && (
            <li>
              <a href="#contact">{isEnglish ? "Contact" : "Contato"}</a>
            </li>
          )}
          <li>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a>
              <ToggleSwitch />
            </a>
          </li>
          <li>
            <button 
              onClick={toggleLanguage}
              className="language-button"
              aria-label="Toggle Language"
            >
              {isEnglish ? "🇧🇷 PT" : "🇺🇸 EN"}
            </button>
          </li>
        </ul>
      </header>
    </Headroom>
  );
}
export default Header;
